import { render } from "./humanityFiveMuseum.vue?vue&type=template&id=e77f2e3c&scoped=true"
import script from "./humanityFiveMuseum.vue?vue&type=script&lang=js"
export * from "./humanityFiveMuseum.vue?vue&type=script&lang=js"

import "./humanityFiveMuseum.vue?vue&type=style&index=0&id=e77f2e3c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77f2e3c"]])

export default __exports__